import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3ReferralPageState() {
  const referralPage = useSelector((state: RootState) => state.treatmentPlanV3.referralPage);
  const referrals = referralPage ?? [];
  const hasLoaded = referralPage !== null;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.referralPageError != null,
  );
  const referralPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.referralPageLoading,
  );
  // Idle (fetch not started) and in-flight both count as loading so the form stays gated.
  const isLoading = referralPageLoading || (!hasLoaded && !hasLoadError);
  const isSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createReferralLoading ||
      state.treatmentPlanV3.updateReferralLoading ||
      state.treatmentPlanV3.deleteReferralLoading,
  );

  return { referrals, isLoading, hasLoaded, hasLoadError, isSaving };
}
